module.exports = __webpack_public_path__ + "fonts/Inter-UI-BlackItalic.woff";